<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
	<path
		d="m14.408 3.45-.058 3.158c-.008.434.267 1.009.617 1.267l2.066 1.567c1.325 1 1.109 2.225-.475 2.725l-2.691.841c-.45.142-.925.634-1.042 1.092l-.642 2.45c-.508 1.933-1.775 2.125-2.825.425L7.892 14.6c-.267-.433-.9-.758-1.4-.733l-2.784.141c-1.991.1-2.558-1.05-1.258-2.566L4.1 9.525c.308-.358.45-1.025.308-1.475l-.85-2.7c-.491-1.583.392-2.458 1.967-1.942l2.458.809C8.4 4.35 9.025 4.258 9.375 4l2.567-1.85c1.391-.992 2.5-.408 2.466 1.3"
	/>
	<path
		d="m17.867 17.059-2.525-2.526a.63.63 0 0 0-.884 0 .63.63 0 0 0 0 .884l2.525 2.525a.62.62 0 0 0 .442.183.62.62 0 0 0 .442-.183.63.63 0 0 0 0-.884"
	/>
</svg>
